import { i18n } from 'i18n'

export enum AbuseCode {
  NO_SIMILARITY = 101,
  BAD_PROPORTIONS = 102,
  NOT_FIT = 103,
  BAD_ITEM = 104,
}

export function getAbuseCodeLabel(code: AbuseCode) {
  switch (code) {
    case AbuseCode.NO_SIMILARITY:
      return i18n('IDontSeeAnySimilarityToMe')
    case AbuseCode.BAD_PROPORTIONS:
      return i18n('IDontLikeTheProportions')
    case AbuseCode.NOT_FIT:
      return i18n('TheItemDoesntFitMe')
    case AbuseCode.BAD_ITEM:
      return i18n('IDontLikeTheItemItself')
    default:
      return '' + code
  }
}
